import React, { useState } from 'react';
import './Login.scss';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import { useHeaderMenu } from "../../contexts/login.context";
import useLoader from '../../contexts/LoaderContext';
import Spinner from '../Spinner/Spinner';
import nvCookieHelpers from '../../services/cookieService';

function Login() {
    const navigate = useNavigate();
    const htmlLang = document.querySelector('html');
    const locale = htmlLang?.getAttribute('lang');
    const [loggedIn, setLoggedIn] = useState(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { LoginUser } = useAuth();
    const { setLoginStatus } = useHeaderMenu();
    const { isLoading, showLoader, hideLoader } = useLoader();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        console.log("HandleSubmit", e);
        if (!loggedIn && email && password) {
            showLoader();
            try {
                await LoginUser(email, password, handleSubmit,handleAuthError);
                hideLoader();
                setShowAlert(true)
            } catch (error) {
                hideLoader();
            }
        } else {
            setShowAlert(true)
        }
    };
    const handleAuthError=()=>{
        if (!loggedIn && nvCookieHelpers.getCookie('isUserLoggedIn')) {
            setShowAlert(true)
        }
    }
    const handleSubmit = (btnType: string) => {
        if (btnType === 'loggedIn') {
            setLoggedIn(true);
            setLoginStatus(true);
            setShowAlert(false);
        }
        // e.preventDefault();
        // Navigate to another route
        navigate(`/${locale}/software/cart/user/${btnType}`);
    };
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleLogin(e as unknown as React.FormEvent);
        }
    };
    return (
        <>
            {isLoading ? (
                <Spinner />
            ) : (<div className="loginContainer">
                <Form onSubmit={handleLogin}>
                    <Form.Group as="fieldset" id="dr_login">
                        <h1>My Account Login</h1>
                        <div id="dr_loginErrorWrap">{showAlert && <p>The Email Address or Password you entered is incorrect. Please try again</p>}</div>
                        <div className="dr_formLine">
                            <Form.Label htmlFor="loginEmail" className="visually-hidden">Email Address</Form.Label>
                            <Form.Control type="text" autoComplete="none" name="loginID" value={email} id="loginEmail" onChange={(e) => setEmail(e.target.value)}  onKeyDown={handleKeyDown}/>
                            <span className="dr_error"></span>
                        </div>
                        <div className="dr_formLine">
                            <Form.Label htmlFor="loginPassword" className="visually-hidden">Password</Form.Label>
                            <Form.Control type="password" name="password" value={password} id="loginPassword" onChange={(e) => setPassword(e.target.value)}  onKeyDown={handleKeyDown}/>
                            <span className="dr_error"></span>
                        </div>
                        <div id="dr_siteButtons">
                            <Button variant="success" className="orderReviewBtn dr_button" type="submit">
                                Login
                            </Button>
                        </div>
                    </Form.Group>
                    {/* <a href={passwordLink} className="passwordLink continue">Forgot Password?</a> */}
                </Form>
            </div>)
            }
        </>
    )
}
export default Login;